const listeners = {};

export function subscribe(eventName, callback) {
  if (!listeners[eventName]) {
    listeners[eventName] = new Set();
  }
  listeners[eventName].add(callback);
  return () => {
    listeners[eventName].delete(callback);
  };
}

export function publish(eventName, payload) {
  if (!listeners[eventName]) return;
  for (const cb of listeners[eventName]) {
    try {
      cb(payload);
    } catch (err) {
      console.error("Event listener error", err);
    }
  }
}
